/* Stops safe-area insets being counted twice when Android already keeps the
   WebView between the system bars, and lifts tiles above the keyboard. */
const docEl = document.documentElement;
let probe;

const rawInset = (side) => {
  const inline = parseFloat(docEl.style.getPropertyValue(`--safe-area-inset-${side}`));
  if (!Number.isNaN(inline)) return inline;
  if (!probe) {
    probe = document.createElement('div');
    probe.style.cssText = 'position:fixed;visibility:hidden;pointer-events:none;'
      + 'padding-top:env(safe-area-inset-top,0px);padding-bottom:env(safe-area-inset-bottom,0px)';
    document.body.appendChild(probe);
  }
  return parseFloat(getComputedStyle(probe)[`padding-${side}`]) || 0;
};

const typing = () => {
  const el = document.activeElement;
  return !!el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.isContentEditable);
};

const evaluate = () => {
  if (typing() || !document.body) return;
  const top = rawInset('top');
  const bottom = rawInset('bottom');
  const portrait = window.innerHeight >= window.innerWidth;
  const full = portrait ? Math.max(window.screen.width, window.screen.height)
                        : Math.min(window.screen.width, window.screen.height);
  const gap = full - window.innerHeight;
  let offTop = false, offBottom = false;
  if (top + bottom > 0 && gap >= top + bottom - 4) { offTop = top > 0; offBottom = bottom > 0; }
  else if (top > 0 && gap >= top - 4) offTop = true;
  else if (bottom > 0 && gap >= bottom - 4) offBottom = true;
  docEl.classList.toggle('bliss-no-inset-top', offTop);
  docEl.classList.toggle('bliss-no-inset-bottom', offBottom);
};

const trackKeyboard = () => {
  const vv = window.visualViewport;
  if (!vv) return;
  const update = () => {
    const kb = typing() ? Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop)) : 0;
    docEl.style.setProperty('--bliss-kb', `${kb}px`);
  };
  vv.addEventListener('resize', update);
  vv.addEventListener('scroll', update);
  document.addEventListener('focusout', () => setTimeout(update, 50));
  update();
};

export const installSafeAreaGuard = () => {
  const run = () => {
    evaluate();
    setTimeout(evaluate, 400);
    setTimeout(evaluate, 1500);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('resize', evaluate);
  window.addEventListener('orientationchange', () => setTimeout(evaluate, 300));
  new MutationObserver(evaluate).observe(docEl, { attributes: true, attributeFilter: ['style'] });
  trackKeyboard();
};
